import React, {useContext, useEffect, useState} from 'react'
import t from 'helpers/I18n'
import { useParams } from 'react-router';
import PropTypes from 'prop-types'
import StepsWrapper from "steps/steps-wrapper";
import BaseParagraph from "components/base-components/base-paragraph";
import BaseButton from "components/base-components/base-button";
import StepsLoader from "../steps-loader";
import { AppDataContext } from '../../../contexts/app-data';
import InputField from '../../base-components/base-input';
import BottomSheet from '../../modals/bottom-sheet';
import { HiOutlineLightBulb } from 'react-icons/hi'

// const _satellite = window._satellite
const PageBus = window.PageBus

const TextBody = () =>(
    <>
    <h3> {t('Welcome_Conditions.title')}</h3>
    <p>{t('Welcome_Conditions.text1')}</p>
    <ul>
        <li>{t('Welcome_Conditions.list.1')}</li>
        <li>{t('Welcome_Conditions.list.2')}</li>
        <li>{t('Welcome_Conditions.list.3')}</li>
        <li>{t('Welcome_Conditions.list.4')}</li>
        <li>{t('Welcome_Conditions.list.5')}</li>
    </ul>
        {/* <p dangerouslySetInnerHTML={{__html: `${t('Welcome_Conditions.text2')}` }} ></p> */}
        {/* <p><b> {t('Welcome_Conditions.text3')} </b></p> */}
    </>
)


const WelcomeStep = () => {
    const lang = localStorage.getItem('language')
    const { state, dispatch } = React.useContext(AppDataContext)
    const [isChecked, setIsChecked] = React.useState(0)
    const [showModal, setShowModal] = useState(false)

    const getInputValue = (name, value) => {
            setIsChecked(value)
        }

    React.useEffect(() => {
        if (PageBus) {
        PageBus.publish("analyticsServices",{
        pageID: "onboarding",
        stepSeq: "0",
        stepName: "welcome:conditions",
        flowType: "sales",
        flowName: "onboarding",
        productName: "onboarding",
        trackMethod: "flow"});
        }
    }, [])
    return (
            // <StepsWrapper stepGroupTitle={t('general.open_pro_account')} title={t('general.open_pro_account')}>
            <StepsWrapper stepGroupTitle={t('general.open_pro_account')} >
                <StepsLoader>
                    <BaseParagraph someProperty={"Title"} >
                    <TextBody />
                    <br />
                    <InputField
                            type={"checkbox"}
                            id={""}
                            error={[]}
                            name={"checkbox"}
                        label={"test"}
                        checkboxlabelbold={true}
                            checkboxLabel={t('Welcome_Conditions.checkbox')}
                            getInputValue={getInputValue}/>
                    </BaseParagraph>
                    <br />

                    <a className={"link"} onClick={() => setShowModal(true)}>
                    <HiOutlineLightBulb />
                    <span>{t('Welcome_Conditions.tooltip')}</span>
                    </a>
                    <br />
                    <br />

                    <div className={"footer-action"} style={{bottom: state.footer_height}}>
                        <BaseButton caption={t('general.continue')} disabled={!isChecked} link={`/${lang.toLowerCase()}/intro`} />
                    </div>

                    {showModal &&
                    <BottomSheet
                        title={""}
                        close={() => {setShowModal(false)}}
                    >
                    <BaseParagraph>
                        <p>{t('Welcome_Conditions.modal.text1')}</p>
                        <p dangerouslySetInnerHTML={{__html: `${t('Welcome_Conditions.modal.text2')}` }}></p>
                    </BaseParagraph>
                    </BottomSheet>}

                </StepsLoader>
            </StepsWrapper>
    )
}

WelcomeStep.propTypes = {
    name: PropTypes.string
}

WelcomeStep.defaultProps = {
    name: "Step01"
}


export default WelcomeStep